import axios from "axios";
import { useEffect } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
// On a custom domain (e.g. grantverify.org) call the API on that same domain so login cookies stay first-party.
const sameSite = window.location.hostname !== "localhost" && window.location.origin !== new URL(BACKEND).origin;
export const API = `${sameSite ? window.location.origin : BACKEND}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const ACQ_DAYS = 30;
export function saveAcquisition(source, ad = "") {
  localStorage.setItem("gv_acq", JSON.stringify({ campaign: "funding_card", source, ad, at: Date.now() }));
}
api.interceptors.request.use((cfg) => {
  try {
    const a = JSON.parse(localStorage.getItem("gv_acq") || "null");
    if (a && Date.now() - a.at < ACQ_DAYS * 864e5) { cfg.headers["X-Acq-Campaign"] = a.campaign; cfg.headers["X-Acq-Source"] = a.source; if (a.ad) cfg.headers["X-Acq-Ad"] = a.ad; }
  } catch { /* ignore bad storage */ }
  if (localStorage.getItem("gv_tour_lang") === "es") cfg.headers["X-Lang"] = "es";
  if (cfg.url === "/auth/me") cfg.headers["X-UI-Lang"] = localStorage.getItem("gv_tour_lang") === "es" ? "es" : "en";
  return cfg;
});

const NO_RETRY = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/google/session"];
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && cfg && !cfg._retry && !NO_RETRY.some((u) => cfg.url.includes(u))) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export async function startCheckout(lookup_key) {
  const { data } = await api.post("/payments/checkout", { lookup_key, origin_url: window.location.origin });
  window.location.href = data.checkout_url;
}

export async function startReviewCheckout(proposal_id) {
  const { data } = await api.post("/reviews/checkout", { proposal_id, origin_url: window.location.origin });
  window.location.href = data.checkout_url;
}

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(res.data);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}

export function usePoll(fn, active, ms = 3000) {
  useEffect(() => {
    if (!active) return;
    const t = setInterval(fn, ms);
    return () => clearInterval(t);
  }, [fn, active, ms]);
}
